import { Input } from 'antd';
import { useEffect } from 'react';
import './TextInputStyle.css';

//takes an onChange prop and calls it with (dataKey, newValue)
const EmailInput = props => {
    const { def, dataKey, data, onChange, state, warning } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";

    useEffect(() => {
        checkEmail(data);
    
    }, [])

    const checkEmail = (value) => {
        //Super-basic email regex; we could go more complicated if we needed to do so.
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);

        const newWarning = value === '' || valid
            ? ''
            : `"${def.label}" must be a valid email address in the form someone@somewhere.com`;
        if (value.length > def.maxLength && (!err || !valid)) {
            return;
        }
        onChange(dataKey, value, newWarning);
    }

    return <Input
        id={def.dataKey}
        readOnly={state.readonly}
        disabled={state.readonly}
        value={data}
        status={err}
        placeholder='someone@somewhere.com'
        onChange={ev => checkEmail(ev.target.value)}
        data-input={'emailinput_de'}
        className={'basicinput_de'}
    />
}

export default EmailInput;
